import { render, staticRenderFns } from "./SpotsManual.vue?vue&type=template&id=0b33315a"
import script from "./SpotsManual.vue?vue&type=script&lang=js"
export * from "./SpotsManual.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports